"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _atoms = require("../../atoms");

var _intl = require("../../intl");

var _RateInput = _interopRequireWildcard(require("./organisms/RateInput"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ID = function ID() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
};

var standardSpacing = 2;
var doubleSpacing = 2 * standardSpacing;

var Body = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "RateCardForm__Body"
})(["padding:", ";"], function (_ref) {
  var spacing = _ref.theme.spacing;
  return (0, _styledComponents.css)(["", " ", ""], spacing(standardSpacing), spacing(doubleSpacing));
});

var Footer = /*#__PURE__*/(0, _styledComponents["default"])(_core.Grid).withConfig({
  displayName: "RateCardForm__Footer"
})(["", ""], function (_ref2) {
  var _ref2$theme = _ref2.theme,
      palette = _ref2$theme.palette,
      spacing = _ref2$theme.spacing;
  return (0, _styledComponents.css)(["background-color:", ";padding:", ";"], palette.grey[50], spacing(standardSpacing));
});

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "RateCardForm__Container"
})(["", ""], function (_ref3) {
  var palette = _ref3.theme.palette;
  return (0, _styledComponents.css)(["background-color:", ";"], palette.background.paper);
});

var Title = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).withConfig({
  displayName: "RateCardForm__Title"
})(["display:block;margin-bottom:", ";"], function (_ref4) {
  var spacing = _ref4.theme.spacing;
  return spacing(standardSpacing);
});

var RateGridItems = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RateGridItems, _React$PureComponent);

  function RateGridItems() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RateGridItems);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RateGridItems)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleRateUpdate = function (changedRate) {
      var _this$props = _this.props,
          rates = _this$props.rates,
          onItemsChange = _this$props.onItemsChange;
      var newRates = rates.map(function (rate) {
        return rate.id === changedRate.id ? changedRate : rate;
      });
      onItemsChange(newRates);
    };

    _this.handleRemove = function (id) {
      var _this$props2 = _this.props,
          rates = _this$props2.rates,
          onItemsChange = _this$props2.onItemsChange;
      var newRatesList = rates.filter(function (rate) {
        return rate.id != id;
      });
      onItemsChange(newRatesList);
    };

    return _this;
  }

  _createClass(RateGridItems, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          rates = _this$props3.rates,
          errors = _this$props3.errors,
          currencySymbol = _this$props3.currencySymbol,
          type = _this$props3.type,
          markupInputProps = _this$props3.markupInputProps,
          rateInputProps = _this$props3.rateInputProps;
      return rates.map(function (rate, index) {
        return _react["default"].createElement(_core.Grid, {
          item: true,
          xs: 12,
          key: "rateItem-".concat(index)
        }, _react["default"].createElement(_RateInput["default"], {
          currencySymbol: currencySymbol,
          type: type,
          rate: _objectSpread({
            id: index
          }, rate),
          onRateUpdate: _this2.handleRateUpdate,
          onRemoveClick: function onRemoveClick(id) {
            return _this2.handleRemove(id);
          },
          error: errors[rate.id],
          markupInputProps: markupInputProps,
          rateInputProps: rateInputProps
        }));
      });
    }
  }]);

  return RateGridItems;
}(_react["default"].PureComponent);

var defaultValidator = function defaultValidator(rates) {
  var individualErrors = rates.reduce(function (acc, rate) {
    if (!rate.name) {
      acc[rate.id] = _RateInput.errorCodes.nameEmpty;
    } else if (rate.type === 'time-rate-card' && rate.amount === undefined) {
      acc[rate.id] = _RateInput.errorCodes.amountEmpty;
    } else if (rate.type === 'expense-rate-card' && rate.markupPercentage === undefined) {
      acc[rate.id] = _RateInput.errorCodes.markupEmpty;
    }

    return acc;
  }, {});
  var ratesByName = rates.reduce(function (acc, rate) {
    var nameList = acc[rate.name] || [];
    nameList.push(rate.id);
    acc[rate.name] = nameList;
    return acc;
  }, {});
  Object.values(ratesByName).forEach(function (nameList) {
    if (nameList.length > 1) {
      nameList.forEach(function (x) {
        return individualErrors[x] = _RateInput.errorCodes.nameNotUnique;
      });
    }
  });
  return individualErrors;
};

var RateCardForm = function RateCardForm(_ref5) {
  var _ref5$rates = _ref5.rates,
      rates = _ref5$rates === void 0 ? [] : _ref5$rates,
      type = _ref5.type,
      currencySymbol = _ref5.currencySymbol,
      onSave = _ref5.onSave,
      title = _ref5.title,
      _ref5$onValidate = _ref5.onValidate,
      onValidate = _ref5$onValidate === void 0 ? defaultValidator : _ref5$onValidate,
      props = _objectWithoutProperties(_ref5, ["rates", "type", "currencySymbol", "onSave", "title", "onValidate"]);

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      formRates = _useState2[0],
      setFormRates = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSaveEnabled = _useState4[0],
      setIsSaveEnabled = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      rateErrors = _useState6[0],
      setRateErrors = _useState6[1];

  var updateErrors = (0, _react.useCallback)(function (rates) {
    var newErrors = onValidate(rates);
    var enableSave = Object.keys(newErrors).length === 0;
    setRateErrors(newErrors);
    setIsSaveEnabled(enableSave);
  }, [rates]);
  var addNewRate = (0, _react.useCallback)(function () {
    var newRates = [].concat(_toConsumableArray(formRates), [{
      id: ID(),
      amount: undefined,
      markupPercentage: undefined,
      name: '',
      type: type,
      amountUntouched: true,
      markupPercentageUntouched: true,
      nameUntouched: true
    }]);
    setFormRates(newRates);
    updateErrors(newRates);
  }, [formRates]);
  (0, _react.useEffect)(function () {
    var updatedRates = rates.map(function (rate) {
      return _objectSpread({
        id: ID()
      }, rate);
    });
    setFormRates(updatedRates);
    updateErrors(updatedRates);
  }, [rates]);
  return _react["default"].createElement(Container, props, _react["default"].createElement(Body, null, _react["default"].createElement(Title, {
    variant: "caption",
    color: "primary"
  }, title), _react["default"].createElement(_core.Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "stretch",
    spacing: 2
  }, formRates.length === 0 ? _react["default"].createElement(_core.Grid, {
    item: true
  }, _react["default"].createElement(_core.Typography, {
    variant: "body1"
  }, _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.form.emptyState"
  }))) : _react["default"].createElement(RateGridItems, {
    rates: formRates,
    errors: rateErrors,
    currencySymbol: currencySymbol,
    type: type,
    markupInputProps: props.markupInputProps,
    rateInputProps: props.rateInputProps,
    onItemsChange: function onItemsChange(value) {
      setFormRates(value);
      updateErrors(value);
    }
  }), _react["default"].createElement(_core.Grid, {
    item: true
  }, _react["default"].createElement(_atoms.Button, {
    size: "small",
    color: "primary",
    onClick: addNewRate,
    startIcon: _react["default"].createElement(_atoms.Icon, {
      icon: "plus",
      size: "small",
      color: "inherit"
    })
  }, _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.form.buttonAddNew"
  }))))), _react["default"].createElement(Footer, {
    container: true,
    direction: "row",
    justify: "flex-end",
    alignItems: "center"
  }, _react["default"].createElement(_core.Grid, {
    item: true
  }, _react["default"].createElement(_atoms.Button, {
    onClick: function onClick() {
      return onSave(formRates);
    },
    disabled: !isSaveEnabled,
    size: "small",
    startIcon: _react["default"].createElement(_atoms.Icon, {
      icon: "check",
      size: "small",
      color: "inherit"
    })
  }, _react["default"].createElement(_intl.IntlMessage, {
    ident: "common.form.save"
  })))));
};

RateCardForm.propTypes = {
  rates: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    amount: _propTypes["default"].number.isRequired,
    markupPercentage: _propTypes["default"].number,
    name: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].string
  })),
  title: _propTypes["default"].string.isRequired,
  currencySymbol: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].oneOf(['time-rate-card', 'expense-rate-card']).isRequired,
  onSave: _propTypes["default"].func.isRequired,
  onError: _propTypes["default"].func,
  onValidate: _propTypes["default"].func,
  markupInputProps: _propTypes["default"].object,
  rateInputProps: _propTypes["default"].object
};
var _default = RateCardForm;
exports["default"] = _default;